// extracted by mini-css-extract-plugin
module.exports = {"layout":"_2VC79zqy1bfN8yQAgeBmM1"};